import {
  CategoriesApi,
  ProductsApi,
} from '@coretava/api/ecommerce-service';
import React from 'react';

export const useProductsApi = (accessToken?: string): ProductsApi => React.useMemo(() => new ProductsApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken,
}), []);

export const useProductCategoriesApi = (accessToken?: string): CategoriesApi => React.useMemo(() => new CategoriesApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken,
}), []);
